import $ from 'Jquery';

class Search {
    // 1. describe and creare
    constructor(){
       this.openButton = $(".js-search-trigger");
       this.closeButton = $(".js-overlay__close");
       this.searchOverlay = $(".search-overlay");
       this.events();
    }
    // 2. events
    events () {
        this.openButton.on("click", this.openOverlay.bind(this));
        this.closeButton.on("click", this.closeOverlay.bind(this));
        $(document).on("keyup",this.keyPressDispatcher.bind(this));
    }


    // 3. methods (function, action)

    openOverlay() {
    this.searchOverlay.addCalss("search-overlay--active");
    $("body").addCalss("body-no-scroll");       
    }
    closeOverlay(){
        this.searchOverlay.removeCalss("search-overlay--active");
        $("body").removeCalss("body-no-scroll"); 
    }

    keyPressDispatcher(){
        console.log("test ediyorum.");
    }
}

export default Search